import React from 'react';

import IndividualDocumentsComponent from '../../presentation/features/individual_documents/IndividualDocumentsComponent/IndividualDocumentsComponent';

const IndividualDocuments: React.FC = () => {
  return (
    <>
      <IndividualDocumentsComponent></IndividualDocumentsComponent>
    </>
  );
};

export default IndividualDocuments;
